import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import PolicyReport from '../../shared/models/policy_report';
import { PolicyType } from '../../shared/enums/policy_type';
import { InvoluntaryRetrenchmentReport, ScholarsReport } from '../../shared/models/report';


@Injectable({
    providedIn: 'root',
})
export class ReportsService {
    private baseUrl = environment.apiUrl;

    constructor(private http: HttpClient) { }

    getPolicies(body: PolicyReport, policyType: PolicyType): Observable<any> {
        if (policyType === PolicyType.MOTOR) {
            return this.fetchMotorPolicies(body);
        } else {
            return this.fetchNonMotorPolicies(body);
        }
    }

    fetchMotorPolicies(body: PolicyReport): Observable<any> {
        return this.http.post(`${this.baseUrl}/api/motor-policy-report`, body);
    }

    fetchTravelReport(dateFrom: string, dateTo: string): Observable<any> {
        return this.http.get(`${this.baseUrl}/api/report/travel-insurance?dateFrom=${dateFrom}&dateTo=${dateTo}`)
    }

    fetchNonMotorPolicies(body: PolicyReport): Observable<any> {
        return this.http.post(`${this.baseUrl}/api/sme/report`, body);
    }

    fetchUsersReports(body: any): Observable<any> {
        return this.http.post(`${this.baseUrl}/api/user/report`, body);
    }

    fetchCustomersReports(body: any): Observable<any> {
        return this.http.post(`${this.baseUrl}/api/customer/report`, body);
    }

    fetchScholarsReport(body: any): Observable<any> {
        return this.http.post(`${this.baseUrl}/api/report/scholars`, body);
    }
}
